import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted } from 'vue'
  import SimulationMap from '@/components/map/SimulationMap.vue'
  import { SimulationUiState, buildSimulationUIStateId } from '@/models/ui/SimulationUiState'
  import MapControl from '@/components/map/MapControl.vue'
  import { MapUiState } from '@/models/ui/MapUiState'
  import store from '@/store'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SimulationDetailMap',
  props: {
    uiid: null
  },
  setup(__props: any) {

const props = __props as {
    uiid: string
  };

  

  const map = ref()
  
  const hideMap = computed(() => store.myGetters.hideMap)
  const missionGlobal = computed(() => store.myGetters.modifiedAdmMissionGlobal)
  
  const map_uiid = computed(() => buildSimulationUIStateId(missionGlobal.value.MIG_ID!, "map"))
  const simulation_uiid = computed(() => buildSimulationUIStateId(missionGlobal.value.MIG_ID!, "detail"))
  
  const simulationState = computed(() => {
    // retourne un SimulationUiState
    return store.myGetters.uistatebyuiid(simulation_uiid.value) as SimulationUiState
  })

  const leftPanelWidth = computed(() => simulationState.value.leftPanelWidth)

  // Watch for leftPanelWidth changes
  watch(leftPanelWidth, (newValue: string) => {
    if (map.value) {
      map.value.updateSize()
    }
  })

  // Watch for map_uiid changes
  watch(map_uiid, (newValue: string) => {
    store.myActions.UI_ENSURE_MAP_STATE(newValue)
  })

  // Created lifecycle - ensure map state
  store.myActions.UI_ENSURE_MAP_STATE(map_uiid.value)

  onMounted(() => {
    setTimeout(() => resizeMap(), 2000)
  })

  function resizeMap() {
    // console.log("resizeMap")
    if (map.value) {
      map.value.updateSize()
    }
  }

return { __sfc: true,props, map, hideMap, missionGlobal, map_uiid, simulation_uiid, simulationState, leftPanelWidth, resizeMap, SimulationMap, MapControl }
}

})